import { css } from '@emotion/react';
import { PaymentMethod } from '@frontend/api-payment-plans';
import { useTranslation } from '@frontend/i18n';
import { useFirstSelectedLocation } from '@frontend/payments-hooks';
import { theme } from '@frontend/theme';
import { Button, Modal, useAlert, useModalControl } from '@frontend/design-system';
import { MultiProcessor } from '..';

const styles = {
  exampleRow: css`
    text-align: center;
    padding: 16px;
    background: ${theme.colors.neutral20};
  `,
  spacer: css`
    margin-bottom: ${theme.spacing(2)};
  `,
};

export const ExamplePaymentMethods = () => {
  const personIds: Record<string, string> = {
    '12fd90e0-8c1b-4ba9-815e-4c7e124131c7': '353b347a-c38f-5653-904e-6b437e5ed88a', // payments express / stripe,
    '8e5060f2-6ebe-48a5-8d4b-b6589180edfe': 'bbfe5050-3116-57e1-b247-69ae3bb39877', // qa-1 / justifi,
  };
  const { locationId } = useFirstSelectedLocation();

  const personId = personIds[locationId || ''];

  const alerts = useAlert();
  const { t } = useTranslation('payments');

  const { triggerProps, modalProps } = useModalControl();

  const onPaymentMethodSelectedSuccess = (pm: PaymentMethod) => {
    console.log('Payment method selected:', pm);
  };

  const onVerificationEmailSent = () => {
    alerts.success(t('ACH verification email sent successfully'));
  };

  const onCancel = () => {
    modalProps.onClose();
  };

  const onError = (message: string, err?: Error) => {
    if (err) {
      console.warn('Caught error from payment methods widget', err);
    }
    if (message) {
      alerts.error(message);
    } else {
      alerts.error(t('An unknown error occurred while attempting to select a payment method.'));
    }
  };
  return (
    <div>
      <h1>Example Payment Methods</h1>
      <div css={styles.exampleRow}>before all</div>
      <MultiProcessor.PaymentMethods
        locationId={locationId || ''}
        personId={personId}
        onPaymentMethodSelectedSuccess={onPaymentMethodSelectedSuccess}
        onVerificationEmailSent={onVerificationEmailSent}
        onCancel={onCancel}
        onError={onError}
      >
        <MultiProcessor.PaymentMethods.View view='list'>
          <MultiProcessor.PaymentMethods.List />
          <div css={styles.exampleRow}>NOTHIGN TO SEE HERE</div>
          <MultiProcessor.PaymentMethods.ListActions />
        </MultiProcessor.PaymentMethods.View>

        <MultiProcessor.PaymentMethods.View view='add-card'>
          <MultiProcessor.PaymentMethods.RelativeContainer>
            <MultiProcessor.PaymentMethods.AddCardForm />
            <div css={styles.exampleRow}>SPLIT UP ACTIONS</div>
            <MultiProcessor.PaymentMethods.CardActions />
          </MultiProcessor.PaymentMethods.RelativeContainer>
        </MultiProcessor.PaymentMethods.View>

        <MultiProcessor.PaymentMethods.View view='add-ach'>
          <MultiProcessor.PaymentMethods.RelativeContainer>
            <MultiProcessor.PaymentMethods.AchForm />
            <div css={styles.exampleRow}>JUST DO IT!</div>
            <MultiProcessor.PaymentMethods.AchActions />
          </MultiProcessor.PaymentMethods.RelativeContainer>
        </MultiProcessor.PaymentMethods.View>
      </MultiProcessor.PaymentMethods>
      <div css={styles.exampleRow}>after all 2</div>

      <div>
        <Button {...triggerProps}>Open Modal</Button>
      </div>
      <Modal minWidth={600} maxWidth={600} {...modalProps}>
        <MultiProcessor.PaymentMethods
          locationId={locationId || ''}
          personId={personId}
          onPaymentMethodSelectedSuccess={onPaymentMethodSelectedSuccess}
          onVerificationEmailSent={onVerificationEmailSent}
          showCancelButtonOnList={true}
          onCancel={onCancel}
          onError={onError}
        >
          <Modal.Header>{t('Payment Methods on File')}</Modal.Header>
          <Modal.Body>
            <MultiProcessor.PaymentMethods.View view='list'>
              <MultiProcessor.PaymentMethods.List />
            </MultiProcessor.PaymentMethods.View>

            <MultiProcessor.PaymentMethods.View view='add-card'>
              <MultiProcessor.PaymentMethods.RelativeContainer>
                <MultiProcessor.PaymentMethods.AddCardForm />
              </MultiProcessor.PaymentMethods.RelativeContainer>
            </MultiProcessor.PaymentMethods.View>

            <MultiProcessor.PaymentMethods.View view='add-ach'>
              <MultiProcessor.PaymentMethods.RelativeContainer>
                <MultiProcessor.PaymentMethods.AchForm />
              </MultiProcessor.PaymentMethods.RelativeContainer>
            </MultiProcessor.PaymentMethods.View>
          </Modal.Body>
          <MultiProcessor.PaymentMethods.FooterActions />
        </MultiProcessor.PaymentMethods>
      </Modal>
    </div>
  );
};
